const initialState = {
  list: [],
  selected: null,
  loading: false,
  error: null
}

const categoryLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CATEGORY_LOCATION_LOADING":
      return { ...state, loading: true, error: null }
    case "GET_ALL_CATEGORY_LOCATIONS": {
      const payload = action.data
      const items =
        (Array.isArray(payload?.data?.categoryLocations) && payload.data.categoryLocations) ||
        (Array.isArray(payload?.data?.items) && payload.data.items) ||
        (Array.isArray(payload?.data?.data) && payload.data.data) ||
        (Array.isArray(payload?.data) && payload.data) ||
        (Array.isArray(payload?.categoryLocations) && payload.categoryLocations) ||
        (Array.isArray(payload?.items) && payload.items) ||
        (Array.isArray(payload) && payload) ||
        []
      return { ...state, list: items, loading: false, error: null }
    }
    case "GET_CATEGORY_LOCATION_BY_ID": {
      const payload = action.data
      // Handle various response structures
      // Note: action.data is res?.data from the API response
      // API response structure: { msg: "...", data: { _id: "...", ... } }
      let selectedData = null
      
      // First, check if payload has a nested data object (common API structure)
      if (payload?.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
        // If payload.data has _id, it's likely the item itself
        if (payload.data._id) {
          selectedData = payload.data
        }
        // Otherwise check for nested structures in payload.data
        else {
          selectedData =
            payload.data?.categoryLocations?.[0] ||
            payload.data?.categoryLocation ||
            payload.data?.category_location ||
            payload.data
        }
      }
      // Check direct payload structures
      else {
        selectedData =
          payload?.categoryLocations?.[0] ||
          payload?.categoryLocation ||
          payload?.category_location ||
          (Array.isArray(payload) && payload.length > 0 ? payload[0] : null) ||
          (payload?._id ? payload : null)
      }
      
      // Debug: Log the extracted data
      console.log('CategoryLocation Reducer - GET_BY_ID:', {
        payload,
        selectedData,
        hasCategoryName: !!selectedData?.category_name,
        hasMetaTitle: !!selectedData?.meta_title,
        categoryName: selectedData?.category_name,
        metaTitle: selectedData?.meta_title
      })
      
      return { ...state, selected: selectedData || null, loading: false }
    }
    default:
      return state
  }
}

export default categoryLocationReducer

